module.exports = new __parcel__URL__("base_raid_back_to_home_btn_gray.6f66140a.png").toString();